{
    "Accessibility Menu": "Menú de accesibilidad",
    "Reset settings": "Restablecer configuración",
    "Close": "Cerrar",
    "Content Adjustments": "Ajustes de contenido",
    "Adjust Font Size": "Ajustar el tamaño de fuente",
    "Highlight Title": "Destacar título",
    "Highlight Links": "Destacar enlaces",
    "Readable Font": "Fuente legible",
    "Color Adjustments": "Ajustes de color",
    "Dark Contrast": "Contraste oscuro",
    "Light Contrast": "Contraste claro",
    "High Contrast": "Alto contraste",
    "High Saturation": "Alta saturación",
    "Low Saturation": "Baja saturación",
    "Monochrome": "Monocromo",
    "Tools": "Herramientas",
    "Reading Guide": "Guía de lectura",
    "Stop Animations": "Detener animaciones",
    "Big Cursor": "Cursor grande",
    "Increase Font Size": "Aumentar tamaño de fuente",
    "Decrease Font Size": "Reducir tamaño de fuente",
    "Letter Spacing": "Espaciado entre letras",
    "Line Height": "Altura de línea",
    "Font Weight": "Grosor de fuente",
    "Dyslexia Font": "Fuente para dislexia",
    "Language": "Idioma",
    "Open Accessibility Menu": "Abrir menú de accesibilidad"
}